import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderby',
  standalone: true,
})
export class OrderByPipe implements PipeTransform {
  transform(
    array: any[],
    fields: string | string[],
    orders: 'asc' | 'desc' | Array<'asc' | 'desc'> = 'asc'
  ): any[] {
    if (!Array.isArray(array) || !fields) {
      return [];
    }

    const fieldList = Array.isArray(fields) ? fields : [fields];
    const orderList = Array.isArray(orders)
      ? orders
      : new Array(fieldList.length).fill(orders || 'asc');

    const normalize = (v: any) => {
      if (v === undefined || v === null) return null;
      if (typeof v === 'string') return v.toLocaleLowerCase();
      if (typeof v === 'boolean') return v ? 1 : 0;
      return v;
    };

    const compare = (a: any, b: any, idx: number): number => {
      const field = fieldList[idx];
      const dir = (orderList[idx] || 'asc').toLowerCase() === 'desc' ? -1 : 1;
      const av = normalize(a?.[field]);
      const bv = normalize(b?.[field]);

      if (av === bv) return 0;
      if (av === null) return 1; // null/undefined vai pro fim
      if (bv === null) return -1;

      if (typeof av === 'string' && typeof bv === 'string') {
        return av.localeCompare(bv, 'pt-BR', { sensitivity: 'base' }) * dir;
      }
      return (av < bv ? -1 : 1) * dir;
    };

    const copy = [...array];
    copy.sort((a, b) => {
      for (let i = 0; i < fieldList.length; i++) {
        const res = compare(a, b, i);
        if (res !== 0) return res;
      }
      return 0;
    });
    return copy;
  }
}
